import React from "react";
import { Box, Heading, Text, Container } from "@chakra-ui/react";

const Career = () => {
  return (
    <Box
      pt="130px"          // keeps space below navbars
      minH="100vh"
      bg="gray.100"
      display="flex"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
    >
      <Container maxW="container.md">
        <Heading mb={4} color="blue.600">
          Careers at Orivanta
        </Heading>

        <Text fontSize="lg" color="gray.600" mb={2}>
          We’re not hiring at the moment.
        </Text>

        <Text fontSize="md" color="gray.500">
          Exciting opportunities are coming soon.  
          Please check back later or stay connected with us.
        </Text>
      </Container>
    </Box>
  );
};

export default Career;
